"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var ProfileSectionTitle = function ProfileSectionTitle(_ref) {
    var children = _ref.children, subhead = _ref.subhead, _ref$shortMargin = _ref.shortMargin, shortMargin = _ref$shortMargin === void 0 ? false : _ref$shortMargin, _ref$labelTransform = _ref.labelTransform, labelTransform = _ref$labelTransform === void 0 ? false : _ref$labelTransform;
    return /*#__PURE__*/ react_1.default.createElement(Header, {
        shortMargin: shortMargin
    }, /*#__PURE__*/ react_1.default.createElement(Title, {
        labelTransform: labelTransform
    }, children), subhead && /*#__PURE__*/ react_1.default.createElement(Subhead, {
        dangerouslySetInnerHTML: {
            __html: subhead
        }
    }));
}; // Styling
var Header = styled_components_1.default.hgroup.withConfig({
    displayName: "ProfileSectionTitle__Header",
    componentId: "rrazdo-0"
})(["margin-bottom:", "px;", "{margin-bottom:", "px;}"], function (props) {
    return !!props.shortMargin ? '24' : '32';
}, _utils_1.mediaQuery('tablet'), function (props) {
    return !!props.shortMargin ? '32' : '40';
});
var Title = styled_components_1.default.h2.withConfig({
    displayName: "ProfileSectionTitle__Title",
    componentId: "rrazdo-1"
})(["", " color:", ";&::before{display:block;height:0;width:0;margin-top:calc((1 - 1.1) * 1em);content:'';}", "{", " font-weight:normal;text-transform:none;letter-spacing:0;}"], function (props) {
    return !!props.labelTransform ? _theme_1.type.labelLarge : _theme_1.type.h3;
}, _theme_1.palette.black, _utils_1.mediaQuery('laptop'), _theme_1.type.h3);
var Subhead = styled_components_1.default.p.withConfig({
    displayName: "ProfileSectionTitle__Subhead",
    componentId: "rrazdo-2"
})(["max-width:420px;padding-top:8px;", " & > p{margin-bottom:0.75em;&:last-of-type{margin-bottom:0;}}", "{max-width:440px;padding-top:13px;}", "{max-width:600px;padding-top:11px;}", "{max-width:680px;padding-top:25px;}"], _theme_1.type.p, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
exports.default = ProfileSectionTitle;
